function AmazonPayoutService(ApiService) {
    'ngInject';
    const service = {};

    service.saveFile = function(payoutForm, orgId, callbackFunc) {
        ApiService.saveFile(`/organizations/${orgId}/amazon_payout_invoices`,{'mapping_id': payoutForm.mapping.id,'file': payoutForm.file}, callbackFunc);
    };

    service.getMappings = function(orgId, callbackFunc) {
        ApiService.get(`/organizations/${orgId}/amazon_payout_mappings/mappings`, callbackFunc);
    };

    service.getInvoices = function(orgId, url, pageNumber, size, callbackFunc) {
        ApiService.get(url, callbackFunc);
    };

    service.allMarketplace = function(orgId, callbackFunc) {
      ApiService.get(`/organizations/${orgId}/amazon_payout_invoices/all_marketplace`, callbackFunc);
    };

    service.getParameterByName = function(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };

    service.getPayoutInvoiceDetails = function(orgId, url, callbackFunc) {
        ApiService.get(url, callbackFunc);
    };

    service.retryInvoiceProcess = function(orgId, invoiceId, forcePost, callbackFunc) {
        ApiService.post(`/organizations/${orgId}/amazon_payout_invoices/${invoiceId}/retry.json`, {force_post: forcePost}, callbackFunc);
    };

    service.tryNow = function(orgnizationId, date, callbackFunc){
      ApiService.post(`/organizations/${orgnizationId}/amazon_payout_invoices/try_now.json`, {date: date}, callbackFunc);
    };

    return service;
}

export default {
    name: 'AmazonPayoutService',
    fn: AmazonPayoutService
};
